import React, { Component, Fragment, useEffect, useRef, useState } from "react";
import { Row, Col, Modal, ModalHeader, ModalFooter, ModalBody, Form, Spinner } from "reactstrap";
import { Helmet } from "react-helmet";
import Title from "../../components/general/AdminPageTitle/AdminPageTitle";
import classes from './Communication.module.scss';
import EditNoteIcon from '@mui/icons-material/EditNote';
import GroupsIcon from '@mui/icons-material/Groups';
import DescriptionIcon from '@mui/icons-material/Description';
import Messenger from "../../components/page/messenger/Messenger/Messenger";
import { Button, Chip, TextField, Switch } from "@mui/material";
import axios from "axios";
import _ from 'lodash';
import Templates from "../../components/page/messenger/Templates/Templates";
import Groups from "../../components/page/messenger/Groups/Groups";
import { boxiPrimary } from "../../assets/style/colors";
import MediaUpload from "../../components/page/messenger/MediaUpload/MediaUpload";
import ScheduleSend from "../../components/page/messenger/ScheduleSend/ScheduleSend";
import AttachFileIcon from '@mui/icons-material/AttachFile';
import CloseIcon from '@mui/icons-material/Close';
import ScheduleIcon from '@mui/icons-material/Schedule';
import { LoadingButton } from "@mui/lab";
import VendorSearch from "../../components/page/messenger/VendorSearch/VendorSearch";
import PhoneNumberExtractor from "../../components/page/messenger/PhoneNumberExtractor/PhoneNumberExtractor";
import ScheduledMessages from "../../components/page/messenger/ScheduleSend/ScheduledMessages";
import { useToastContext } from "../../wrappers/ToastContext";
import moment from "moment";
import { IconButton } from "@mui/material";
import PhotoCameraRoundedIcon from '@mui/icons-material/PhotoCameraRounded';
import { useParams } from 'react-router-dom';

const CommunicationPage = () => {
  const allowedCharacters = /^[0-9+\-()\s;]*$/;

  const { vendorName , phoneNumber, vendorId} = useParams();

  const { toast } = useToastContext();

  const [activeTab, setActiveTab] = useState(0);
  
  const [isComposePopupOpen, setIsComposePopupOpen] = useState(false);
  const [isSummaryPopupOpen, setIsSummaryPopupOpen] = useState(false);


  const [inputValue, setInputValue] = useState(null);
  const [manualNumberValue, setManualNumberValue] = useState(null);
  const [isVendorSearchLoading, setIsVendorSearchLoading] = useState(true);
  const [vendors, setVendors] = useState(null);
  const [selectedVendors, setSelectedVendors] = useState([]);
  const [messageInputValue, setMessageInputValue] = useState('');
  const [isMessageSending, setMessageSending] = useState(false);
  const [isTemplateModalOpen, setIsTemplateModalOpen] = useState(false);
  const [isGroupsModalOpen, setIsGroupsModalOpen] = useState(false);
  
  const [isMediaUploadModalOpen, setIsMediaUploadModalOpen] = useState(false);
  const [uploadedImageURL, setUploadedImageURL] = useState([]);
  const [imagePath, setImagePath] = useState(null);
  
  const [templateSelectionType, setTemplateSelectionType] = useState(null);
  const [templateForMessage, setTemplateForMessage] = useState(null);

  const [schedule, setSchedule] = useState(null);
  const [isScheduleModalOpen, setIsScheduleModalOpen] = useState(false);

  const [selectedGroup, setSelectedGroup] = useState(null);
  const [selectedGroupType, setSelectedGroupType] = useState(null);

  const [allThreadsCount, setAllThreadsCount] = useState(0);
  const [unreadCount, setUnreadCount] = useState(0);
  const [starredCount, setStarredCount] = useState(0);
  const [accountingCount, setAccountingCount] = useState(0);
  const [picturesCount, setPicturesCount] = useState(0)

  const [isSearchPopupOpen, setIsSearchPopupOpen] = useState(false);

  const [isSelection, setIsSelection] = useState(false);
  const [checked, setChecked] = useState([]);

  const [manualAddedNumbers, setManualAddedNumbers] = useState([]);
  const [isScheduledMessagesModalOpen, setIsScheduledMessagesModalOpen] = useState(false);
  const [vendorsSelectedToSend, setVendorsSelectedToSend] = useState([])

  const [messagesSent, setMessagesSent] = useState(0);

  const [totalSelectedMessages, setTotalSelectedMessages] = useState([]);
  const [successMessages, setSuccessMessages] = useState([]);
  const [failedMessages, setFailedMessages] = useState([]);

  // this state is used to track we want to select contact or not
  const [threadShouldSelected, setThreadShouldSelected] = useState(true);

  
  const manualNumberInputRef = useRef(null);
  const pictureBlastToggle = useRef(false)


  
  // useEffect(() => {
  //   getAllThreadsChatCount();
  // }, [])

  const selectTab = (index) => {
    setActiveTab(index)
    setTimeout(() => {
      index === 1 && window.dispatchEvent(new Event('resize'));
    }, 1);
  }

  useEffect(() => {
    if (templateForMessage) setMessageInputValue(templateForMessage?.template_body);
  }, [templateForMessage])

  useEffect(() => {
    if (messageInputValue === '') setTemplateForMessage(null)
  }, [messageInputValue])


  useEffect(() => {
    if (inputValue === '') setVendors([])
  }, [inputValue]);

  useEffect(() => {
    const debouncedHandler = _.debounce(value => {
      if (value) {
        setIsVendorSearchLoading(true)
        console.log('loading vendors');
        searchVendors();
        setIsVendorSearchLoading(false)
      } else {
        setVendors(null);
        setIsVendorSearchLoading(false)
      }
    }, 2000);

    debouncedHandler(inputValue);

    return () => {
      debouncedHandler.cancel();
    };
  }, [inputValue]);

  // phase 1 task 
  const updatePictureBlastToggle = () => {
    pictureBlastToggle.current = !pictureBlastToggle.current
    if(pictureBlastToggle.current){
      setMessageInputValue('Hi, this is Boxi, please send pictures of all 4 sides of your truck/s + MUDFLAPS for this months picture reporting. Thank you!')
    }else {
      setMessageInputValue('')
    }
  }
  const searchVendors = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_HOST}/communication/chat/search-vendor/${inputValue}`);
      console.log(res.data.vendors);
      setVendors(res.data.vendors)
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    const tempVendorsSelectedToSend = []
    if (checked && checked.length > 0) tempVendorsSelectedToSend.push(...checked.flatMap((obj) => obj.vendors).map((vendor) => formatPhoneNumberToE164(vendor.phone_number)))
    if (selectedVendors && selectedVendors.length > 0) tempVendorsSelectedToSend.push(...selectedVendors.map(val => formatPhoneNumberToE164(val.phone_num)));
    if (tempVendorsSelectedToSend.indexOf(manualNumberValue == -1)) tempVendorsSelectedToSend.push(...manualAddedNumbers)

    setVendorsSelectedToSend(tempVendorsSelectedToSend)
    console.log("🚀 ~ tempVendorsSelectedToSend:", tempVendorsSelectedToSend)
  }, [checked, selectedVendors, manualAddedNumbers])

  // const sendSMS = async () => {
  //   if(messageInputValue?.trim()?.length > 0 || uploadedImageURL?.length > 0) {
  //     try {
  //       setMessageSending(true);
  //       for (const phone_number of vendorsSelectedToSend) {
  //         const body = {
  //           to: phone_number, 
  //           body: messageInputValue && messageInputValue?.trim()?.length > 0 ? messageInputValue.trim() : '', 
  //           sender_id: JSON.parse(localStorage.getItem("userId")),
  //           isPictures: pictureBlastToggle.current
  //         }
  
  //         if (uploadedImageURL.length > 0) body['media'] = uploadedImageURL;
  //         if (schedule) body['schedule'] = schedule.toISOString();
  //         const res = await axios.post(`${process.env.REACT_APP_API_HOST}/communication/send`, body)
  //         setMessagesSent((prev) => prev + 1);
  //         // if(pictureBlastToggle.current){
  //         //   await getPicturesChatCount();
  //         // }
  //       }
  //       setTimeout(() => {
  //         setMessageInputValue('');
  //         setMessageSending(false);
  //         setSchedule(null);
  //         setImagePath(null);
  //         setUploadedImageURL([]);
  //         setVendors([]);
  //         setSelectedVendors([]);
  //         closeComposeModal();
  //         setIsGroupsModalOpen(false);
  //         setSelectedGroup(null);
  //         setSelectedGroupType(null);
  //         setTemplateSelectionType(null);
  //         setMessagesSent(0);
  //         pictureBlastToggle.current = false;
  //       }, 1000);
  //     } catch (error) {
  //       console.error(error);
  //       setMessageSending(false);
  //     }
  //   }
  // }
  // const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  async function sendSMS() {
    try {
      if(messageInputValue?.trim()?.length > 0 || uploadedImageURL?.length > 0) {
        setMessageSending(true);
        const smsPromises = [];

        setTotalSelectedMessages(vendorsSelectedToSend);
  
        if (pictureBlastToggle.current) await axios.post(`${process.env.REACT_APP_API_HOST}/communication/add-last-picture-blast-timestamp`);

        for (const phone_number of vendorsSelectedToSend) {
          try {
            const body = {
              to: phone_number, 
              body: messageInputValue && messageInputValue?.trim()?.length > 0 ? messageInputValue.trim() : '', 
              sender_id: JSON.parse(localStorage.getItem("userId")),
              isPictures: pictureBlastToggle.current
            }
    
            if (uploadedImageURL.length > 0) body['media'] = uploadedImageURL;
            if (schedule) body['schedule'] = schedule.toISOString();
            const res = await axios.post(`${process.env.REACT_APP_API_HOST}/communication/send`, body)
            setMessagesSent((prev) => prev + 1);
            setSuccessMessages((prev) => [...prev, phone_number]);
            smsPromises.push({ status: 'fulfilled', phone_number, response: res });
          } catch (error) {
            console.error(`Failed to send SMS to ${phone_number}:`, error);
            setFailedMessages((prev) => [...prev, phone_number]);
            smsPromises.push({ status: 'rejected', phone_number, reason: error });
          }
        }
  
        const results = await Promise.allSettled(smsPromises);
  
        // Handle the results, including both fulfilled and rejected promises
        results.forEach((result) => {
          if (result.status === 'fulfilled') {
            // Handle successful SMS
          } else if (result.status === 'rejected') {
            // Handle failed SMS
            const { phone_number, reason } = result;
            console.log(`Failed to send SMS to ${phone_number}`);
          }
        });
  
        setTimeout(() => {
          setMessageInputValue('');
          setMessageSending(false);
          setSchedule(null);
          setImagePath(null);
          setUploadedImageURL([]);
          setVendors([]);
          setSelectedVendors([]);
          closeComposeModal();
          setIsGroupsModalOpen(false);
          setSelectedGroup(null);
          setSelectedGroupType(null);
          setTemplateSelectionType(null);
          setMessagesSent(0);
          getPicturesChatCount();
          setIsSummaryPopupOpen(true);
          pictureBlastToggle.current = false;
        }, 1000);
      }
    } catch (error) {
      console.error(error);
      setMessageSending(false);
    }
  }
  
  const addVendorToSelectedList = (vendor) => {
    console.log(vendor);
    if (!checkIfVendorIsSelected(vendor)) {
      const tempSelectedVendors = _.cloneDeep(selectedVendors)
      tempSelectedVendors.push(vendor);
      setSelectedVendors(tempSelectedVendors)
      setVendors([]);
      setInputValue('');
    }
  }
  const checkIfVendorIsSelected = (vendor) => {
    return selectedVendors.map(v => v.phone_num).indexOf(vendor.phone_num) === -1 ? false : true;
  } 

  const handleDeleteChip = (vendor) => {
    const tempSelectedVendors = _.cloneDeep(selectedVendors);
    setSelectedVendors(tempSelectedVendors.filter(v => v.phone_num !== vendor.phone_num))
  }

  const getCampaignGroups = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_HOST}/communication/group/campaigns`);
      console.log(res.data.campaigns);
    } catch (error) {
      console.log(error);
    }
  }

  const closeComposeModal = () => {
    setMessageInputValue('');
    setImagePath(null);
    setUploadedImageURL([]);
    setSchedule(null);
    setVendors([]);
    setSelectedVendors([]);
    setSelectedGroup(null);
    setIsComposePopupOpen(false);
    setChecked([]);
    setInputValue('');
    setManualNumberValue('');
    setManualAddedNumbers([]);
    setTemplateSelectionType(null);
  }

  const closeSummaryModal = () => {
    setIsSummaryPopupOpen(false);
    setTemplateSelectionType(null);
    setSuccessMessages([]);
    setFailedMessages([]);
  }

  const getAllThreadsChatCount = async () => {
    try {
      const chats = await axios.get(`${process.env.REACT_APP_API_HOST}/communication/chats/all`);
      setAllThreadsCount(chats?.data?.allCount)
      setUnreadCount(chats?.data?.unreadCount)
      setStarredCount(chats?.data?.starredCount)
      setAccountingCount(chats?.data?.accountingCount)
      setPicturesCount(chats?.data?.picturesCount)
    } catch (error) {
      console.log(error);
    }
  };
  
  const getPicturesChatCount = async () => {
    try {
      const chats = await axios.get(`${process.env.REACT_APP_API_HOST}/communication/chats/pictures`);
      setPicturesCount(chats?.data?.chats?.length)
    } catch (error) {
      console.log(error);
    }
  };

  const handleGroupToggle = (value) => {
    let currentIndex = -1;

    if (value.campaign_id) {
      currentIndex = checked.map(val => val.name).indexOf(value.name)
    } else if (value.city) {
      currentIndex = checked.map(val => val.city).indexOf(value.city)
    } else if (value.id) {
      currentIndex = checked.map(val => val.id).indexOf(value.id)
    } else {
      currentIndex = checked.map(val => val.vendorGroupName).indexOf(value.vendorGroupName)
    }

    const newChecked = _.cloneDeep(checked);

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
    console.log(newChecked)
  };

  // useEffect(() => {
  //   if (manualNumberValue?.includes(';') && (manualNumberValue.substring(0, manualNumberValue.length - 1).length === 10 || manualNumberValue.substring(0, manualNumberValue.length - 1).length === 12 || manualNumberValue.substring(0, manualNumberValue.length - 1).length === 14 )) {
  //     let splittedNumbers = manualNumberValue?.split(';').map(number => formatPhoneNumberToE164(number));
  //     console.log("🚀 ~ file: Communication.js:275 ~ useEffect ~ splittedNumbers:", splittedNumbers)
  //     splittedNumbers = splittedNumbers.slice(0, splittedNumbers.length -1)
  //     console.log("🚀 ~ file: Communication.js:275 ~ useEffect ~ splittedNumbers:", splittedNumbers)
  //     if (splittedNumbers?.length > 0) {
  //       let tempManualAddedNumbers = _.cloneDeep(manualAddedNumbers);
  //       tempManualAddedNumbers = [...tempManualAddedNumbers, ...splittedNumbers.filter(number => number !== '')];
  //       setManualAddedNumbers(tempManualAddedNumbers);
  //       setManualNumberValue('');
  //     }
  //   }
  // }, [manualNumberValue])

  const handleManualNumberDeleteChip = (number) => {
    const tempManualAddedNumbers = _.cloneDeep(manualAddedNumbers);
    setManualAddedNumbers(tempManualAddedNumbers.filter(n => n !== number))
  }

  const formatPhoneNumberToE164 = (phoneNumber) => {
    if (phoneNumber !== '') {
      const numericPhoneNumber = phoneNumber.replace(/\D/g, '');
      return numericPhoneNumber.length === 10 ? `+1${numericPhoneNumber}` : `+${numericPhoneNumber}`;
    }
  }

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      const newInputValue = manualNumberValue + ';';
      setManualNumberValue(newInputValue);
  
      let inputParts = []
      if (newInputValue.includes(';')) inputParts = newInputValue.split(';');
  
      // Iterate through parts and validate them
      for (const part of inputParts) {
        const trimmedPart = part.trim(); // Remove extra spaces
        if (validatePhoneNumber(trimmedPart)) {
          let tempManualNumbers = _.cloneDeep(manualAddedNumbers)
          tempManualNumbers = tempManualNumbers.filter(number => number !== formatPhoneNumberToE164(trimmedPart))
          tempManualNumbers.push(formatPhoneNumberToE164(trimmedPart))
          console.log("🚀 ~ file: Communication.js:358 ~ handleInputChange ~ tempManualNumbers:", tempManualNumbers)
          setManualAddedNumbers(tempManualNumbers);
          setManualNumberValue('');
        }
      }
    }
  };

  const handlePaste = (event) => {
    const clipboardData = event.clipboardData;
    const pastedData = clipboardData.getData('text/plain');
    const cleanedData = pastedData.replace(/;\s+/g, ';');
    event.preventDefault();
    setManualNumberValue(cleanedData);
  };


  const sendToAll = async () => {
    try {
      const chats = await axios.post(`${process.env.REACT_APP_API_HOST}/communication/send-to-all`, {});
    } catch (error) {
      console.log(error);
    }
  }

  const handleInputChange = (event) => {
    if (event.target.value.match(allowedCharacters)) {
      const newInputValue = event.target.value;
      setManualNumberValue(newInputValue);
  
      let inputParts = []
      if (newInputValue.includes(';')) inputParts = newInputValue.split(';');
  
      // Iterate through parts and validate them
      for (const part of inputParts) {
        const trimmedPart = part.trim(); // Remove extra spaces
        if (validatePhoneNumber(trimmedPart)) {
          let tempManualNumbers = _.cloneDeep(manualAddedNumbers)
          tempManualNumbers = tempManualNumbers.filter(number => number !== formatPhoneNumberToE164(trimmedPart))
          tempManualNumbers.push(formatPhoneNumberToE164(trimmedPart))
          console.log("🚀 ~ file: Communication.js:358 ~ handleInputChange ~ tempManualNumbers:", tempManualNumbers)
          setManualAddedNumbers(tempManualNumbers);
          setManualNumberValue('');
        }
      }
    }
  };

  const validatePhoneNumber = (value) => {
    // Validate the three formats
    const validFormats = [
      /^\d{10}$/, // 1112223333
      /^\+1\d{10}$/, // +12223334444
      /^\(\d{3}\)\s?\d{3}-\d{4}$/, // (222) 333-4444
      /^\+1\(\d{3}\)\s?\d{3}-\d{4}$/, // +1(222) 333-4444
      /^\+1\s\(\d{3}\)\s?\d{3}-\d{4}$/ // +1 (222) 333-4444

    ];
    // Check if the value matches any of the valid formats
    return validFormats.some((format) => format.test(value));
  };

  const removeImage = (index) => {
    let tempUploadedImageURL = _.cloneDeep(uploadedImageURL)
    let tempImagePath = _.cloneDeep(imagePath)

    tempUploadedImageURL = tempUploadedImageURL.filter((val, i) => i !== index)
    tempImagePath = tempImagePath.filter((val, i) => i !== index)

    setUploadedImageURL(tempUploadedImageURL)
    setImagePath(tempImagePath)
  }

 // phase 1
  return (
    <Fragment>
      {/* <Loading loading={isLoading} label="Loading Campaigns..." /> */}
      <Helmet>
        <title>Boxi Admin | Communication</title>
      </Helmet>
      {/* Top row */}
      <Row>
        <Col xs="7">
          <div className={classes.tabs}>
            <div onClick={() => selectTab(0)} className={activeTab === 0 ? classes.activeTab : classes.tab}>
              <div className={classes.tabName}>All Threads</div>
              <div className={classes.threadsCount}>{allThreadsCount}</div>
            </div>
            <div onClick={() => selectTab(1)} className={activeTab === 1 ? classes.activeTab : classes.tab}>
              <div className={classes.tabName}>Unread</div>
              <div className={classes.threadsCount}>{unreadCount}</div>
            </div>
            <div onClick={() => selectTab(2)} className={activeTab === 2 ? classes.activeTab : classes.tab}>
              <div className={classes.tabName}>Starred</div> 
              <div className={classes.threadsCount}>{starredCount}</div>
            </div>
            <div onClick={() => selectTab(3)} className={activeTab === 3 ? classes.activeTab : classes.tab}>
              <div className={classes.tabName}>Accounting</div> 
              <div className={classes.threadsCount}>{accountingCount}</div>
            </div>
            <div onClick={() => selectTab(4)} className={activeTab === 4 ? classes.activeTab : classes.tab}>
              <div className={classes.tabName}>Pictures</div> 
              <div className={classes.threadsCount}>{picturesCount}</div>
            </div>
          </div>
        </Col>
        <Col xs="5">
          <div style={{ display: 'flex', alignItems: 'center', columnGap: 10, justifyContent: 'flex-end' }}>
            <div onClick={() => setIsComposePopupOpen(true)} className={classes.actionButtonContainer}>
              <EditNoteIcon />
              <div>Compose</div>
            </div>
            <div onClick={() => setIsGroupsModalOpen(true)} className={classes.actionButtonContainer}>
              <GroupsIcon />
              <div>Groups</div>
            </div>
            <div onClick={() => setIsTemplateModalOpen(true)} className={classes.actionButtonContainer}>
              <DescriptionIcon />
              <div>Templates</div>
            </div>
            <div onClick={() => setIsScheduledMessagesModalOpen(true)} className={classes.actionButtonContainer}>
              <ScheduleIcon />
              <div>Scheduled</div>
            </div>
          </div>
        </Col>
      </Row>

      {activeTab === 0 && <Row style={{minHeight: 'calc(100vh - 90px)'}} className="mt-3">
        {/* <PhoneNumberExtractor /> */}
        <Messenger type="all" totalCounts={{ 0: allThreadsCount, 1: unreadCount, 2: starredCount, 3: accountingCount, 4: picturesCount }} setAllThreadsCount={setAllThreadsCount} setUnreadCount={setUnreadCount} setStarredCount={setStarredCount} setAccountingCount={setAccountingCount} setPicturesCount={setPicturesCount} activeTab={activeTab} setThreadShouldSelected={setThreadShouldSelected} threadShouldSelected={threadShouldSelected} selectedVendorDetails={ (vendorName && setThreadShouldSelected) ?  {vendorName , vendorId , phoneNumber} : null}/>
      </Row>}
      {activeTab === 1 && <Row style={{minHeight: 'calc(100vh - 90px)'}} className="mt-3">
        <Messenger type="unread" totalCounts={{ 0: allThreadsCount, 1: unreadCount, 2: starredCount, 3: accountingCount, 4: picturesCount }} setAllThreadsCount={setAllThreadsCount} setUnreadCount={setUnreadCount} setStarredCount={setStarredCount} setAccountingCount={setAccountingCount} setPicturesCount={setPicturesCount} activeTab={activeTab} setThreadShouldSelected={setThreadShouldSelected} threadShouldSelected={threadShouldSelected}/>
      </Row>}
      {activeTab === 2 && <Row style={{minHeight: 'calc(100vh - 90px)'}} className="mt-3">
        <Messenger type="starred" totalCounts={{ 0: allThreadsCount, 1: unreadCount, 2: starredCount, 3: accountingCount, 4: picturesCount }} setAllThreadsCount={setAllThreadsCount} setUnreadCount={setUnreadCount} setStarredCount={setStarredCount} setAccountingCount={setAccountingCount} setPicturesCount={setPicturesCount} activeTab={activeTab} setThreadShouldSelected={setThreadShouldSelected} threadShouldSelected={threadShouldSelected}/>
      </Row>}
      {activeTab === 3 && <Row style={{minHeight: 'calc(100vh - 90px)'}} className="mt-3">
        <Messenger type="accounting" totalCounts={{ 0: allThreadsCount, 1: unreadCount, 2: starredCount, 3: accountingCount, 4: picturesCount }} setAllThreadsCount={setAllThreadsCount} setUnreadCount={setUnreadCount} setStarredCount={setStarredCount} setAccountingCount={setAccountingCount} setPicturesCount={setPicturesCount} activeTab={activeTab} setThreadShouldSelected={setThreadShouldSelected} threadShouldSelected={threadShouldSelected}/>
      </Row>}
      {activeTab === 4 && <Row style={{minHeight: 'calc(100vh - 90px)'}} className="mt-3">
        <Messenger type="pictures" totalCounts={{ 0: allThreadsCount, 1: unreadCount, 2: starredCount, 3: accountingCount, 4: picturesCount }} setAllThreadsCount={setAllThreadsCount} setUnreadCount={setUnreadCount} setStarredCount={setStarredCount} setAccountingCount={setAccountingCount} setPicturesCount={setPicturesCount} activeTab={activeTab} setThreadShouldSelected={setThreadShouldSelected} threadShouldSelected={threadShouldSelected}/>
      </Row>}

      {/* compose popup start */}
      {isComposePopupOpen && <Modal backdrop="static" className="composeModal" isOpen={isComposePopupOpen} toggle={() => closeComposeModal()}>
        <ModalHeader toggle={() => closeComposeModal()}>Compose</ModalHeader>
        <ModalBody>
          <div className={classes.composeForm}>
            {checked && checked.length > 0 && <div className={classes.groupTo}>
              <span className={classes.toPart}>Groups:</span>
              <div style={{ display: 'flex', alignItems: 'center', columnGap: 10, rowGap: 10, overflow: 'auto' }}>
                {checked.length > 0 && checked.map((group, index) => {
                  return (
                    <Chip
                      key={index}
                      label={group.name ? group.name : group.city ? group.city : group.group_name ? group.group_name : group.vendorGroupName ? group.vendorGroupName : null}
                      onDelete={() => handleGroupToggle(group)}
                    />
                  )
                })}
              </div>
            </div>}
            <div>
              {selectedVendors && selectedVendors.length > 0 && <div className={classes.groupTo} style={{ marginBottom: 10, alignItems: 'center' }}>
                <span className={classes.toPart}>Vendors:</span>
                <div style={{ display: 'flex', alignItems: 'center', columnGap: 10, rowGap: 10, overflow: 'auto' }}>
                  {!isSearchPopupOpen && selectedVendors && selectedVendors.length > 0 && selectedVendors.map((vendor, index) => {
                    return (
                      <Chip
                        key={index}
                        label={vendor.name}
                        onDelete={() => handleDeleteChip(vendor)}
                      />
                    )
                  })}
                </div>
              </div>}
              <TextField
                id="standard-search"
                label="Add Number(s)"
                type="text"
                ref={manualNumberInputRef}
                onKeyDown={handleKeyPress}
                variant="outlined"
                onPaste={handlePaste}
                className={`${manualAddedNumbers?.length > 0 ? 'customTextFieldWithSelectedResultsWithNoSearchValue' : 'customTextField'}`}
                value={manualNumberValue}
                // onChange={handleManualNumberInput}
                onChange={handleInputChange}
                helperText="Only numbers and special characters (+, -, (, ), space, ; are allowed)"
                InputProps={manualAddedNumbers.length > 0 ? {
                  startAdornment: <div style={{ display: 'flex', alignItems: 'center', columnGap: 10, overflow: 'auto' }}>{manualAddedNumbers.map((number, index) => {
                    if (number !== '') return (
                      <Chip
                        key={index}
                        label={number}
                        onDelete={() => handleManualNumberDeleteChip(number)}
                      />
                    )
                  })}</div>
                } : null}
              />
              <Button onClick={() => setIsSearchPopupOpen(true)}>Add Vendors</Button>
              <Button onClick={() => { setIsGroupsModalOpen(true); setIsSelection(true); }}>Add Groups</Button>
              {/* <Button onClick={() => sendToAll()}>Send To All</Button> */}
            </div>
            <div className={classes.textAreaWrapper}>
              <textarea 
                type="text" 
                className={`form-control ${classes.textArea}`} 
                placeholder={"Text message..." }
                aria-label="Text message" 
                aria-describedby="send-button" 
                onChange={(e) => setMessageInputValue(e.target.value)} 
                value={messageInputValue} 
                rows={5} 
                style={{resize: 'none'}}
              ></textarea>
              {schedule && <div className={classes.schedule}>
                <div>Message is scheduled to be sent on {schedule.format('MMMM Do')} at {schedule.format('hh:mm A')}</div>
              </div>}
              <div className={classes.options}>
                <AttachFileIcon onClick={() => setIsMediaUploadModalOpen(true)} style={{ color: boxiPrimary, cursor: 'pointer' }} />
                <DescriptionIcon onClick={() => { setIsTemplateModalOpen(true); setTemplateSelectionType('selection') }} style={{ color: boxiPrimary, cursor: 'pointer' }} />
                <ScheduleIcon onClick={() => setIsScheduleModalOpen(true)} style={{ color: boxiPrimary, cursor: 'pointer' }} />
                <IconButton
                style={{ margin: 0, padding: 0}}
                disabled={!(vendorsSelectedToSend.length > 0)}
                onClick={() => updatePictureBlastToggle()}
                >
                  <PhotoCameraRoundedIcon
                  style={{
                    color: pictureBlastToggle.current ? boxiPrimary : 'gray',
                    cursor: 'pointer',
                  }}
                />
                </IconButton>
                {templateForMessage && <div className={classes.templateInUse}>
                <div>Template in use: {templateForMessage?.template_name}</div>
              </div>}
              </div>
            </div>
            {imagePath && imagePath.length > 0 && <div className="d-flex align-items-center" style={{ columnGap: 12, height: 60, overflow: 'auto' }}>
              {imagePath.map((image, index) => (
                <div className={classes.imagePath}>
                  {image.file_name}
                  <CloseIcon style={{ color: boxiPrimary, cursor: 'pointer' }} onClick={() => removeImage(index)} />
                </div>
              ))}
            </div>}
            {vendorsSelectedToSend && vendorsSelectedToSend.length > 0 && <div style={{ fontSize: 12, color: '#00000099' }}>{vendorsSelectedToSend.length} phone numbers selected</div>}
          </div>
          {isMessageSending && vendorsSelectedToSend && vendorsSelectedToSend.length > 0 && 
            <>
              <div style={{ fontSize: 12, color: '#00000099', marginTop: 16, marginBottom: 5, display: 'flex', alignItems: 'center', columnGap: 10 }}><Spinner size='sm' style={{ color: boxiPrimary }} /> Sending messages...</div>
              <div style={{ display: 'flex', alignItems: 'center', columnGap: 10 }}>
                <div style={{ fontSize: 12 }}>{messagesSent}/{vendorsSelectedToSend.length}</div>
                <div style={{ position: 'relative', width: '100%', height: 5, borderRadius: 50, background: '#e3e3e3' }}>
                  <div style={{ position: 'absolute', top: 0, left: 0, width: `${(messagesSent/vendorsSelectedToSend.length) * 100}%`, height: 5, borderRadius: 50, background: boxiPrimary, transition: '0.2s ease-in-out' }}></div>
                </div>
              </div>
            </>
          }
        </ModalBody>
        <ModalFooter>
          {/* <Button disabled={isMessageSending} color="primary" onClick={() => sendToAll()}>
            Send To All
          </Button> */}
          <LoadingButton loading={isMessageSending} disabled={isMessageSending || (messageInputValue?.trim() === '' && uploadedImageURL.length === 0) || vendorsSelectedToSend.length === 0} color="primary" onClick={() => sendSMS()}>
          {schedule ? 'Schedule' : 'Send'}
          </LoadingButton>
          <Button disabled={isMessageSending} color="secondary" onClick={() => closeComposeModal()}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>}
      {/* compose popup end */}

      {/* compose popup start */}
      {isSummaryPopupOpen && <Modal backdrop="static" className="composeModal" isOpen={isSummaryPopupOpen} toggle={() => closeSummaryModal()}>
        <ModalHeader toggle={() => closeSummaryModal()}>Summary</ModalHeader>
        <ModalBody>
          <div className={classes.composeForm}>
            <div>Total Messages Attempt: { totalSelectedMessages.length }</div>
            {successMessages && <div>Successful Messages: <span>{ successMessages.length }</span></div>}
            {failedMessages && <div>Failed Messages: <span>{ failedMessages.length }</span></div>}
            {failedMessages && failedMessages.length > 0 && 
              <ul style={{ maxHeight: 300, overflow: 'auto' }}>
                {failedMessages.map((number, index) => {
                  return (
                    <li>{ number }</li>
                  )
                })}
              </ul>
            }
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => closeSummaryModal()}>
            Close
          </Button>
        </ModalFooter>
      </Modal>}

      {isGroupsModalOpen && <Groups isSelection={isSelection} setIsSelection={setIsSelection} handleGroupToggle={handleGroupToggle} checked={checked} openModal={setIsGroupsModalOpen} isModalOpen={isGroupsModalOpen} isComposePopupOpen={isComposePopupOpen} setIsComposePopupOpen={setIsComposePopupOpen} setSelectedGroup={setSelectedGroup} setSelectedGroupType={setSelectedGroupType} />}
      {isMediaUploadModalOpen && <MediaUpload openModal={setIsMediaUploadModalOpen} isModalOpen={isMediaUploadModalOpen} setUploadedImageURL={setUploadedImageURL} setImagePath={setImagePath} />}
      {isScheduleModalOpen && <ScheduleSend openModal={setIsScheduleModalOpen} isModalOpen={isScheduleModalOpen} setMessageSchedule={setSchedule} />}
      {isTemplateModalOpen && <Templates openModal={setIsTemplateModalOpen} isModalOpen={isTemplateModalOpen} type={templateSelectionType} setTemplateForMessage={setTemplateForMessage} />}
      <VendorSearch isSearchPopupOpen={isSearchPopupOpen} setIsSearchPopupOpen={setIsSearchPopupOpen} selectedVendors={selectedVendors} setSelectedVendors={setSelectedVendors} />
      {isScheduledMessagesModalOpen && <ScheduledMessages openModal={setIsScheduledMessagesModalOpen} isModalOpen={isScheduledMessagesModalOpen} />}
    </Fragment>
  );
}

export default CommunicationPage;
